var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"adaptive":true,"height":"auto","width":"700","name":_vm.name}},[_c('div',{staticClass:"p-4 lg:p-8"},[_c('iframe',{staticClass:"w-full max-h-screen",staticStyle:{"height":"700px"},attrs:{"id":"cookie-policy-iframe"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }